import React from 'react'
import withIcon from '@/components/withIcon'

const IconMark = ({ className }) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.585 0.539982C12.8779 0.832876 12.8779 1.30775 12.585 1.60064L2.08502 12.1006C1.79212 12.3935 1.31725 12.3935 1.02436 12.1006C0.731464 11.8077 0.731464 11.3329 1.02436 11.04L11.5244 0.539982C11.8173 0.247089 12.2921 0.247089 12.585 0.539982Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.02436 0.539982C0.731464 0.832876 0.731464 1.30775 1.02436 1.60064L11.5244 12.1006C11.8173 12.3935 12.2921 12.3935 12.585 12.1006C12.8779 11.8077 12.8779 11.3329 12.585 11.04L2.08502 0.539982C1.79212 0.247089 1.31725 0.247089 1.02436 0.539982Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default withIcon(IconMark)
